import axios from "axios";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import AlertBox from "../../component/AlertBox";
import { CircularProgress } from "@mui/material";
import NotFound from "../../assets/not-found.png";
import ButtonCompo from "../../component/ButtonCompo";

function AttendanceRequest() {
  const { attendanceId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [somethingError, setSomethingError] = useState(false);
  const [requestData, setRequestData] = useState({});
  const [reload, setReload] = useState(false)

  // fetch attendance request
  async function getAttendanceReq() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/attendance/request/${attendanceId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setRequestData(res.data?.data);
    } catch (error) {
      console.log(error);
      setSomethingError(true);
    } finally {
      setLoading(false);
    }
  }

  async function approveRequest(status) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/attendance/request/approve/${requestData?._id}/${status}`,
        method: "get",
        withCredentials: true,
      });
      setReload(prev => !prev)
      setOpen(true);
      setSuccess(true);
      setMessage("Leave has been added");
    } catch (error) {
      console.log(error);
      setOpen(true);
      setSuccess(false);
      setMessage("Leave add failed");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    getAttendanceReq();
  }, [attendanceId, reload]);

  if (somethingError) {
    return (
      <div className="mt-[5rem] flex flex-col justify-center items-center w-full">
        <img src={NotFound} />
        <p className="w-full text-center text-slate-500 font-medium text-[18px]">
          Attendance request not found
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="w-full h-[90vh] flex justify-center items-center">
        <CircularProgress size={"60px"} />
      </div>
    );
  }

  return (
    <>
      <div className="w-full flex justify-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[95vw] md:w-[30rem] p-5 border mt-5 rounded-[10px] shadow-md">
          <h1 className="text-center text-[19px] font-medium">
            Attendance Request
          </h1>
          <div className="mt-5 w-full px-5 space-y-3">
            <section className="grid-cols-2 grid">
              <p className="font-medium">Applicant Name</p>
              <p className="text-slate-700">{requestData?.user?.fullName}</p>
            </section>
            <section className="grid-cols-2 grid">
              <p className="font-medium">Request Type</p>
              <p className="text-slate-700">{requestData?.reqType}</p>
            </section>
            <section className="grid-cols-2 grid">
              <p className="font-medium">Reason</p>
              <p className="text-slate-700">{requestData?.reason}</p>
            </section>
            {requestData?.reqType !== "Shift Change" ? (
              <section className="grid-cols-2 grid">
                <p className="font-medium">Date</p>
                <p className="text-slate-700">{`${requestData?.dayOfMonth}-${requestData?.month}-${requestData?.year}`}</p>
              </section>
            ) : (
              ""
            )}
            <section className="grid-cols-2 grid">
              <p className="font-medium">Clock In</p>
              <p className="text-slate-700">{requestData?.clockin}</p>
            </section>
            <section className="grid-cols-2 grid">
              <p className="font-medium">Clock Out</p>
              <p className="text-slate-700">{requestData?.clockout}</p>
            </section>
            <section className="grid-cols-2 grid">
              <p className="font-medium">Explanation</p>
              <p className="text-slate-700">{requestData?.remarks}</p>
            </section>
            <section className="grid-cols-2 grid">
              <p className="font-medium">Status</p>
              <p className="text-slate-700">
                {requestData?.isApproved === undefined ? (
                  <span className="bg-yellow-200 text-yellow-700 px-3 py-1 text-[15px] rounded-full font-medium">
                    Pending
                  </span>
                ) : requestData?.isApproved === true ? (
                  <span className="bg-green-200 text-green-700 px-3 py-1 text-[15px] rounded-full font-medium">
                    Approved
                  </span>
                ) : (
                  <span className="bg-red-200 text-red-700 px-3 py-1 text-[15px] rounded-full font-medium">
                    Rejected
                  </span>
                )}
              </p>
            </section>
          </div>
          {requestData?.isApproved === undefined && (
            <div className="w-full flex justify-center items-center gap-3 mt-5">
              <ButtonCompo
                variant={"contained"}
                color={"success"}
                onClick={() => approveRequest("Approved")}
              >
                Approve
              </ButtonCompo>
              <ButtonCompo
                variant={"contained"}
                color={"error"}
                onClick={() => approveRequest("Rejected")}
              >
                Reject
              </ButtonCompo>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default AttendanceRequest;
